import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { PacientService } from "src/services/pacient.service";
import {
  LoadingController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import { AvaliacaoRacService } from "../../../services/avaliacao-rac.service";
import { CalendarModal } from "ion2-calendar";
import * as moment from "moment";
import { AutocompleteSelectorComponent } from "../autocomplete-selector/autocomplete-selector.component";
import { CalendarModalOptions } from "ion2-calendar/dist/calendar.model";

@Component({
  selector: "app-atendimentos-list-component",
  templateUrl: "atendimentos-list-component.html",
  styleUrls: ["./atendimentos-list-component.scss"],
})
export class AtendimentosListComponent implements OnInit {
  emptyState = {
    imgUrl: "/assets/imgs/bg-atendimentos.svg",
    title: "O paciente não possui registro de atendimento",
    text: "Essa área é dedicada à apresentação de dados relacionados aos registros de atendimentos ou internações do paciente.",
  };

  emptyStateFiltered = {
    imgUrl: "/assets/imgs/bg-atendimentos.svg",
    title:
      "O paciente não possui registro de atendimento com o filtro aplicado",
    text: "Essa área é dedicada à apresentação de dados relacionados aos registros de atendimentos do paciente com o filtro aplicado.",
  };

  next: any;
  userFiltro: any;
  caraterSelecionado: any;
  list: any = [];
  procedimentosData: any = [];
  caraterAtendimentoData: any = [];
  cnesData: any = [];
  cidData: any = [];
  cnesFilter: any;
  cidFilter: any;

  filtrosSelecionados: any = [];
  atendimentosList: any = [];
  atendimentosListFiltered: any = [];
  dtInicio: any;
  dtFim: any;
  listaFiltro = [];
  conteudoRevelado = false;

  @Output() atendimentoClicked = new EventEmitter();
  @ViewChild("cnesFilterSelector")
  cnesFilterSelector: AutocompleteSelectorComponent;
  @ViewChild("cidFilterSelector")
  cidFilterSelector: AutocompleteSelectorComponent;
  @ViewChild("procedimentoFilterSelector")
  procedimentoFilterSelector: AutocompleteSelectorComponent;
  @ViewChild("caraterAtendimentoFilterSelector")
  caraterAtendimentoFilterSelector: AutocompleteSelectorComponent;

  constructor(
    private pacient: PacientService,
    private racService: AvaliacaoRacService,
    private loadingCtrl: LoadingController,
    private modalCtrl: ModalController,
    private toastController: ToastController
  ) { }

  async ngOnInit() {
    await this.loadData();

    console.log(this.atendimentosList);

    this.atendimentosList.forEach((att) => {
      if (!this.listaFiltro.includes(att.nmEstabelecimento)) {
        this.listaFiltro.push(att.nmEstabelecimento);
      }
    });
  }

  ordem(lista) {
    return lista.sort((a, b) => {
      let oldDateFormatA = moment(a.dtAtualizacao, "DD-MM-YYYY HH:mm")
        .local()
        .format("MM-DD-YYYY HH:mm");
      let oldDateFormatB = moment(b.dtAtualizacao, "DD-MM-YYYY HH:mm")
        .local()
        .format("MM-DD-YYYY HH:mm");
      let newDateA = new Date(oldDateFormatA);
      let newDateB = new Date(oldDateFormatB);

      return Number(newDateB.getTime()) - Number(newDateA.getTime());
    })
  }

  // async detalhar(atendimento) {
  //   this.atendimentoClicked.emit(atendimento);
  // }

  async loadData() {
    let loading = await this.loadingCtrl.create({});
    await loading.present();

    try {
      this.atendimentosList = await this.racService.getList();
      console.log(this.atendimentosList);
      this.loadFilter();
      this.formatarConteudo(false);

      // if (this.atendimentosList) {
      //   await this.loadSelectFilters();
      // }
    } catch (e) {
      console.error("error", e);
    }

    await loading.dismiss();
  }

  async loadFilter() {
    this.atendimentosList.forEach((rac) => {
      if (
        this.cnesData.findIndex((cnes: any) => cnes.coCnes === rac.coCnes) ===
        -1
      )
        this.cnesData.push({
          coCnes: rac.coCnes,
          nmEstabelecimento: rac.nmEstabelecimento,
          display: `${rac.coCnes} - ${rac.nmEstabelecimento}`,
        });
      rac.atestados.forEach((atestado) => {
        atestado.diagnostico.forEach((diag: any) => {
          if (
            diag.CID10 !== "-" &&
            this.cidData.findIndex((cid: any) => cid.CID10 === diag.CID10) ===
            -1
          )
            this.cidData.push({
              CID10: diag.CID10,
              nmCID10: diag.nmCID10,
              display: `${diag.CID10} - ${diag.nmCID10}`,
            });
        });
      });
      // rac.procedimentos.forEach((procedimento) => {
      //   if (
      //     this.procedimentosData.findIndex(
      //       (proc: any) => proc === procedimento.nome
      //     ) === -1
      //   )
      //     this.procedimentosData.push(procedimento.nome);
      // });
      // if (
      //   this.caraterAtendimentoData.findIndex(
      //     (carater: any) => carater === rac.caraterAtendimento
      //   ) === -1
      // )
      //   this.caraterAtendimentoData.push(rac.caraterAtendimento);
    });
  }

  formatarConteudo(hidden: boolean) {
    this.atendimentosListFiltered = this.atendimentosList.map((att) => Object.assign({
      tipo: "ATENDIMENTO CLÍNICO",
      nome: "Atendimento",
      dtAtualizacao: att.dtAtendimento,
      estabelecimento: att.nmEstabelecimento,
      dtSolicitacao: "-",
      telefoneSolicitacao: "-",
      enderecoSolicitacao: "-",
      modalidade: "-",
      especialidade: "-",
      motivo: "-",
      dtExecucao: att.dtAtendimento,
      telefoneExecucao: "-",
      enderecoExecucao: "-",
      cid: att.coCid,
      cnes: att.coCnes,
    }, att));

    if (hidden) {
      this.atendimentosListFiltered = this.atendimentosListFiltered.splice(
        0,
        3
      );
    }
  }

  revelarConteudo() {
    this.formatarConteudo(false);
    this.conteudoRevelado = true;
  }

  async loadSelectFilters() {
    this.atendimentosList.forEach((atendimento) => {
      atendimento.procedimentos.forEach((procedimento) => {
        if (
          !this.procedimentosData.find((proc) => procedimento.nome === proc)
        ) {
          this.procedimentosData.push(procedimento.nome);
        }
      });

      if (
        !this.caraterAtendimentoData.find(
          (caraterAtendimento) =>
            atendimento.caraterAtendimento === caraterAtendimento
        )
      ) {
        this.caraterAtendimentoData.push(atendimento.caraterAtendimento);
      }

      if (!this.cnesData.find((coCnes) => atendimento.coCnes === coCnes)) {
        this.cnesData.push(atendimento.coCnes);
      }

      if (
        !this.cidData.find(
          (diagnostico) => atendimento.diagnostico === diagnostico
        )
      ) {
        this.cidData.push(atendimento.diagnostico);
      }
    });
  }

  get cnesDataDisplay() {
    return this.cnesData.map((cnes) => cnes.display);
  }
  get cidDataDisplay() {
    return this.cidData.map((cid) => cid.display);
  }

  async openCalendar(field) {
    if (!this.dtInicio || !this.dtFim) {
      const options: CalendarModalOptions = {
        id: field,
        pickMode: "single",
        title: "Selecione as datas desejadas",
        doneLabel: "",
        closeLabel: "",
        autoDone: true,
        canBackwardsSelected: true,
        step: 12,
        weekdays: ["D", "S", "T", "Q", "Q", "S", "S"],
        weekStart: 0,
      };

      const modal = await this.modalCtrl.create({
        component: CalendarModal,
        keyboardClose: true,
        cssClass: "modal-calendar",
        componentProps: { options },
      });

      modal.onDidDismiss().then((event) => {
        this[field] = moment(event.data.string, "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        );
        this.filter();
        return;
      });
      return modal.present();
    } else if (this[field]) {
      this[field] = null;
      await this.filter();
      return;
    }
  }

  addFilter(data, tipo) {
    if (!data) {
      return;
    }

    const filtro = {
      tipo,
      data,
    };

    this.revelarConteudo();

    if (!this.filtrosSelecionados.includes(filtro)) {
      this.filtrosSelecionados.push(filtro);
    }

    this.filter();
  }

  async filter(datas?: any) {
    if (datas) {
      this.dtInicio = datas.dtInicio;
      this.dtFim = datas.dtFim;
    }
    this.revelarConteudo();

    if (this.dtInicio && !moment(this.dtInicio, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data de início invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtInicio = null;
    }
    if (this.dtFim && !moment(this.dtFim, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data fim invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtFim = null;
    }

    if (this.dtInicio && this.dtFim) {
      this.atendimentosListFiltered = this.atendimentosListFiltered.filter(
        (atendimento) => {
          const dtAtendimento = moment(atendimento.dtAtualizacao, "DD/MM/YYYY");
          const dtInicio = moment(this.dtInicio, "DD/MM/YYYY").subtract(1, "d");
          const dtFim = moment(this.dtFim, "DD/MM/YYYY").add(1, "d");
          return dtAtendimento.isBetween(dtInicio, dtFim);
        }
      );
    }

    if (this.filtrosSelecionados.length) {
      const cidFiltro = this.filtrosSelecionados
        .filter((filter) => filter.tipo === "cidFilter")
        .map((filter) => filter.data.split(' - ')[0]);
      const cnesFiltro = this.filtrosSelecionados
        .filter((filter) => filter.tipo === "cnesFilter")
        .map((filter) => filter.data.split(' - ')[0]);

      this.atendimentosListFiltered = this.atendimentosListFiltered.filter(
        (att) => {
          console.log(att);
          let count = 0;
          if (cidFiltro.length) {
            if (cidFiltro.includes(att.cid)) {
              count += 1;
            }
          }
          if (cnesFiltro.length) {
            if (cnesFiltro.includes(att.cnes)) {
              count += 1;
            }
          }
          return !!count;
        }
      );
    }
  }

  async limparFiltro(field, filtro?) {
    if (field === "dtFim" || field === "dtInicio") {
      this[field] = null;
    }

    if (field === "box-filter") {
      this.filtrosSelecionados = filtro;
    }
    this.formatarConteudo(false);
    this.filter();
  }

  async clearFilter() {
    Object.assign(this.atendimentosListFiltered, this.atendimentosList);
    this.dtInicio = null;
    this.cnesFilter = null;
    this.cidFilter = null;
    // this.procedimentoSelecionado = null;
    this.caraterSelecionado = null;
    await this.cnesFilterSelector.clearQuery();
    await this.cidFilterSelector.clearQuery();
    await this.procedimentoFilterSelector.clearQuery();
    await this.caraterAtendimentoFilterSelector.clearQuery();
    await this.filter();
  }
}
